import { IGlobalState } from './types';
import { LanguageList, ThemeList } from '../globalTypes';
import { themesList } from '../../../constants/themesList';
import Helpers from 'utils/Helpers';

const initialGlobalState = (): IGlobalState => {
  const storedTheme = localStorage.getItem('theme') as ThemeList;
  const validTheme =
    storedTheme && themesList[storedTheme]
      ? storedTheme
      : ThemeList.DEEP_BLUE_THEME;

  if (storedTheme && !themesList[storedTheme]) {
    localStorage.setItem('theme', validTheme);
  }

  return {
    error: null,
    loading: false,
    scheme: validTheme,
    lang: (localStorage.getItem('lang') as LanguageList) || LanguageList.EN,
    searchParams: '',
    activeFilters: {},
    superAdmin: false,
    isSuperAdmin: false,
    mainOrganization: localStorage.getItem('mainOrganization')
      ? JSON.parse(localStorage.getItem('mainOrganization')!)
      : null,
    bruAssigned: localStorage.getItem('bruAssigned')
      ? JSON.parse(localStorage.getItem('bruAssigned')!)
      : null,
    schemaTables: [],
    hierarchicalLevelsScope: Helpers.loadOrgContext()
  };
};

export default initialGlobalState;
